import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PAGE_INDEX, PAGE_SIZE } from '~/utils/constants/common';
import { SortDirectionEnum } from '~/utils/enum';
import { IActionLog, IParamsActionLog } from '~/utils/interface/actionLog';
import { handleGetListActionLog } from './actionLogThunk';

export interface ActionLogState {
  actionLogs: Array<IActionLog>;
  filter: IParamsActionLog;
  totalItems: number;
  needRefreshData: boolean;
}

const initialState: ActionLogState = {
  actionLogs: [],
  totalItems: 0,
  needRefreshData: false,
  filter: {
    username: '',
    search: '',
    startDate: '',
    endDate: '',
    sortBy: '',
    sortOrder: SortDirectionEnum.ASC,
    pageIndex: PAGE_INDEX,
    pageSize: PAGE_SIZE,
  },
};

const actionLogSlice = createSlice({
  name: 'actionLog',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IParamsActionLog>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    resetFilter: (state) => {
      state.filter = initialState.filter;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetListActionLog.pending, (_state, _action) => {})
      .addCase(handleGetListActionLog.fulfilled, (state, action) => {
        const data = action.payload?.result?.data;
        state.actionLogs = Array.isArray(data) ? data : [];
        state.totalItems = action.payload.result.total_record || 0;
        state.needRefreshData = false;
      })
      .addCase(handleGetListActionLog.rejected, (_state, _action) => {});
  },
});

export const actionLogActions = actionLogSlice.actions;

const actionLogReducer = actionLogSlice.reducer;
export default actionLogReducer;
